import { formatDateForInput } from './formatDateForInput';

export function formatIsoDateForInput(date: string): string {
  return formatDateForInput(new Date(date));
}
